import React, { useState, useEffect } from 'react';
import vetcandidateanswer from '../../apis/vettest/vetcandidateanswer';
import vetinterviewanalysis from '../../apis/vettest/vetinterviewanalysis';
import { useInterview } from '../../hooks/useinterviewhook';
import assessmentprofile from '../../apis/vettest/assessmentprofile';
import {useLocation } from 'react-router-dom';
const SubmitAnswerButton = ({
  questionNumber,
  questionData,
  candidateTestId,
  isLastQuestion,           
  isLastQuestionOfSection,  
  onNext,
  audioBlob = null,
  transcript = '',
  recordingTime = 0,
  textAnswer = '',
  selectedOptionId = null,
  selectedSequence = [],
  testType = 'audio',
  disabled = false,
  hasRecorded = false,
  timeRemaining = null,
  isRecording = false,
  onStopRecording = null,
  getVideoDuration = null,
  getTotalExamVideoDuration = null,
  section,
  sectionQuestions = []

}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [hasAutoSubmitted, setHasAutoSubmitted] = useState(false);
  const [hasTimeStarted, setHasTimeStarted] = useState(false);
  const { uploadAudioToBlob } = useInterview(null);
  const location = useLocation();
  const normalizedPhoneData = {
    phoneNumber: (location.state?.phoneNumber || '').toString().trim(),
    countryCode: location.state?.userLocation?.code || location.state?.countryCode || '',
    countryCallingCode: (location.state?.countryCallingCode || location.state?.userLocation?.dialCode || '').toString().trim()
  };
  const handleSubmit = async () => {
    if (isUploading) return; 

    try {
      setIsUploading(true);

      let answerPayload = {
        questionId: questionData?.id || null,
        vetCandidateTestId: candidateTestId,
        isEnd: isLastQuestion ? true : false,
        videoDuration: 0
      };

      if (getVideoDuration) {
        answerPayload.videoDuration = getVideoDuration();
      }

      if (testType === 'audio') {
        let finalAudioUrl = null;
        if (audioBlob) {
          finalAudioUrl = await uploadAudioToBlob({
            audioBlob,
            userId: candidateTestId,
            containerName: 'vetinterview',
            subfolder: 'audio',
            questionNumber,
            recordingTime,
            contentType: 'audio/mp3',
            fileExtension: 'mp3'
          });
        }
        answerPayload.audioFname = finalAudioUrl || null;
        answerPayload.transcriptText = transcript || null;
      } else if (testType === 'text') {
        answerPayload.answerText = textAnswer || null;
      } else if (testType === 'multiple-choice') {
        answerPayload.selectedOptionId = selectedOptionId || null;
        answerPayload.answerText = textAnswer || null;
      } else if (testType === 'sentence-build') {
        answerPayload.selectedSequence = selectedSequence.length > 0 ? JSON.stringify(selectedSequence) : null;
        answerPayload.answerText = textAnswer || null;
      }

      const response = await vetcandidateanswer(answerPayload);

      if (isLastQuestionOfSection && response.status === 201) {
        const questionIds = sectionQuestions.map(q => q.id || '');
        const payload = {
          vetCandidateTestId: candidateTestId,
          sectionId: section?.id,
          isEnd: isLastQuestion ? true : false,
          questionIds: JSON.stringify(questionIds)
        };

        if (isLastQuestion) {
          try {
            await vetinterviewanalysis(payload);
             assessmentprofile({
                    "id": candidateTestId,
                    "assessmentType": "vet",
                    "userLocation": location.state?.userLocation || null,
                    "phoneNumber": normalizedPhoneData.phoneNumber,
                    "countryCode": normalizedPhoneData.countryCode,
                    "countryCallingCode": normalizedPhoneData.countryCallingCode
                  })
          } catch (analysisError) {
            console.warn("Analysis API failed:", analysisError);
          }
        } else {
          const analysisPromise = vetinterviewanalysis(payload);
          analysisPromise.catch(analysisError => {
            console.warn("Section analysis failed (non-blocking):", analysisError);
          });
        }
      }

      setIsUploading(false);
      if (onNext) {
        onNext();
      }

    } catch (error) {
      console.error("Submit Answer Error:", error);
      setIsUploading(false);
    }
  };

  useEffect(() => {
    if (timeRemaining > 0 && !hasTimeStarted) {
      setHasTimeStarted(true);
    }

    if (hasTimeStarted && timeRemaining === 0 && !hasAutoSubmitted && !isUploading) {
      setHasAutoSubmitted(true);
      if (isRecording && onStopRecording) {
        onStopRecording();
        setTimeout(() => handleSubmit(), 800);
      } else {
        handleSubmit();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRemaining]);

  return (
    <button 
      className="btn-submit-answer" 
      onClick={handleSubmit}
      disabled={disabled || isUploading}
    >
      {isUploading ? 'Submitting...' : (isLastQuestion ? 'Submit Test' : 'Next Question')}
    </button>
  );
};

export default SubmitAnswerButton;